import {useContext} from 'react';
import {HeaderContext} from './header/context';

export default function SiteName() {
    const headerStore = useContext(HeaderContext);
    const siteName = headerStore.useNewDesign ? 'Data Products Platform' : 'Torch Insight';

    return <span>{siteName}</span>;
}